import * as React from 'react';

const TrainIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="train-illustration"
    >
      <mask
        id="train-mask0"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="2"
        width="22"
        height="28"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.3335 29.3333H22.6668C24.876 29.3333 26.6668 27.5424 26.6668 25.3333V23C26.6668 19.5022 23.8313 16.6666 20.3335 16.6666H11.6668C8.16903 16.6666 5.3335 19.5022 5.3335 23V25.3333C5.3335 27.5424 7.12436 29.3333 9.3335 29.3333ZM16.0002 2.66663C19.3139 2.66663 22.0002 5.35292 22.0002 8.66663C22.0002 11.9803 19.3139 14.6666 16.0002 14.6666C12.6865 14.6666 10.0002 11.9803 10.0002 8.66663C10.0002 5.35292 12.6865 2.66663 16.0002 2.66663Z"
          fill="white"
        />
      </mask>
      <g mask="url(#train-mask0)">
        <rect
          x="0.666992"
          width="32"
          height="32"
          rx="2"
          fill="url(#train-gradient0)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.12088 12.8986L10.418 14.7754C10.9485 15.0773 11.2799 15.6279 11.2873 16.2195L11.3334 19.8966C11.3408 20.4883 11.0231 21.0312 10.5 21.3209L7.24886 23.1212C6.72574 23.4109 6.07665 23.4033 5.54611 23.1014L2.24899 21.2246C1.71845 20.9226 1.38707 20.3721 1.37966 19.7804L1.33362 16.1033C1.32622 15.5116 1.64391 14.9687 2.16704 14.679L5.41813 12.8787C5.94126 12.589 6.59034 12.5966 7.12088 12.8986Z"
        fill="#C2F3EA"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.8594 14C23.4972 14 22.2228 14.6725 21.4537 15.7971L12.1956 29.3333H23.0396C24.6644 29.3333 26.0735 28.2273 26.4686 26.663L26.4978 26.5403L28.837 15.4225C28.8482 15.3692 28.8557 15.3153 28.8595 15.261L28.8623 15.1795C28.8623 14.5281 28.3344 14 27.6833 14H24.8594Z"
        fill="#107461"
        style={{ mixBlendMode: 'multiply' }}
      />
      <defs>
        <linearGradient
          id="train-gradient0"
          x1="16.667"
          y1="-6"
          x2="-5.33301"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#47DCC0" />
          <stop offset="1" stopColor="#2CBE7C" />
        </linearGradient>
      </defs>
    </svg>
  );
});

TrainIllustration.displayName = 'TrainIllustration';

export { TrainIllustration };
